module.exports = "/assets/6c1089a8dbd60cb15f16fbe9b7f7f95f.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/JQ.png
// module id = 1519
// module chunks = 0